export default __webpack_public_path__ + "static/media/Wall_Conveyor_Perpendicular_Orange.256.70d7e33c.png";